<template>
  <q-page class="q-pa-md">
    <h1 class="text-h5 text-white">Logistics & Supply Chain</h1>
    <p>We provide real-time tracking, predictive analytics, and warehouse automation for logistics companies.</p>
  </q-page>
</template>
